import { atom } from 'jotai';

import { getCardNameByCode } from '@/lib/constants/card';

export interface PaymentCard {
  cardNm: string;
  cardNo: string;
  cardCd: string;
  expireYear: string;
  expireMonth: string;
}

export interface PaymentCardData {
  result: boolean;
  cards: PaymentCard[];
}

export const paymentCardDataAtom = atom<PaymentCardData | null>(null);

export const paymentCardLoadingAtom = atom<boolean>(false);

export const paymentCardErrorAtom = atom<string | null>(null);

export const hasRegisteredCardAtom = atom((get) => {
  const cardData = get(paymentCardDataAtom);
  return cardData?.result && cardData?.cards && cardData.cards.length > 0;
});

export const firstCardAtom = atom((get) => {
  const cardData = get(paymentCardDataAtom);
  return cardData?.cards?.[0] || null;
});

export const cardNameAtom = atom((get) => {
  const firstCard = get(firstCardAtom);
  return firstCard?.cardCd ? getCardNameByCode(firstCard.cardCd) : '';
});

export const cardNumberAtom = atom((get) => {
  const firstCard = get(firstCardAtom);
  return firstCard?.cardNo ? `${firstCard.cardNo.slice(0, 4)}-****-****-${firstCard.cardNo.slice(-4)}` : '';
});
